import { gql } from 'graphql-request'

export const GET_CAMPAIGN_LIST = gql`
  query CampaignList(
    $page: Int
    $limitPerPage: Int
    $searchText: String
    $type: CampaignType
    $status: CampaignStatus
  ) {
    campaignList(
      page: $page
      limitPerPage: $limitPerPage
      searchText: $searchText
      type: $type
      status: $status
    ) {
      data {
        id
        name
        type
        status
        bookCount
        startDate
        endDate
        createdAt
        updatedAt
      }
      total
      page
    }
  }
`
